import React from 'react';
import Link from 'next/link';
import { Container, Button } from 'react-bootstrap';
import { FaShieldHalved, FaMagnifyingGlass } from 'react-icons/fa6';
import { http, report } from '@/helpers/index';
import Report from '@/components/reports/base';
import Seo from '@/components/seo';
import CtaBanner from '@/components/site/cta-banner';
import { useRouter } from 'next/router';

export default function ModelGeneric({ item }) {
  const router = useRouter();
  const product = item?.product ? item.product.name : '';
  const pageTitle = product ? `Exemplo de Laudo - Consulta ${product} | AboutCar` : 'Modelo de Consulta Veicular | AboutCar';
  const pageDescription = product
    ? `Veja um modelo de exemplo do relatório completo da Consulta ${product} da AboutCar. Saiba quais informações sobre leilão, sinistro, débitos e restrições são retornadas.`
    : 'Exemplo de relatório e modelo de consulta de histórico veicular por placa da AboutCar.';

  return (
    <>
      <Seo
        title={pageTitle}
        description={pageDescription}
        keywords={`modelo laudo veicular, exemplo consulta ${product.toLowerCase()}, modelo relatorio placa, laudo veiculo`}
      />
      <Container className="model my-4">
        {!product && (
          <h2 className="text-center">Modelo da Consulta não encontrado</h2>
        )}
        {item && product && (
          <>
            {/* Header CTA Banner */}
            <div className="bg-primary-subtle border border-primary-subtle rounded-4 p-3 p-md-4 mb-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 shadow-sm">
              <div className="d-flex align-items-center gap-3">
                <div className="p-3 bg-primary text-white rounded-circle d-none d-sm-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '48px', height: '48px' }}>
                  <FaShieldHalved size={22} />
                </div>
                <div>
                  <h3 className="h5 fw-bold text-dark mb-1">
                    {`Modelo Demonstrativo: Consulta ${product}`}
                  </h3>
                  <p className="text-secondary small mb-0">
                    Este é um exemplo com dados fictícios. Quer consultar o histórico real de qualquer veículo por placa?
                  </p>
                </div>
              </div>
              <Button
                variant="primary"
                className="btn-gradient-primary rounded-pill px-4 py-2 fw-bold text-nowrap border-0 shadow-sm d-inline-flex align-items-center justify-content-center gap-2 flex-shrink-0"
                onClick={() => router.push(`/consulta/rapida/${item.product?.i18n ?? 'completa'}`)}
              >
                <FaMagnifyingGlass size={16} />
                <span>Consultar Agora</span>
              </Button>
            </div>

            <h2 className="text-center fw-bold text-dark mb-3">{`Modelo da Consulta ${product}`}</h2>
            <Report item={item} />

            {/* Bottom CTA Banner */}
            <div className="mt-5">
              <CtaBanner code={item.product?.i18n} />
            </div>
          </>
        )}
      </Container >
    </>
  );
}

export async function getServerSideProps(context) {
  const { code } = context.query;
  const res = await http.baseAsync('GET', `/histories/model/${code}`);
  const item = await res.json();
  if (!item?._id) {
    return {
      notFound: true,
    };
  }
  item.model = code;
  return { props: { item: report.configure([item]) } };
}
